import { useEffect, useState } from "react";
import { Save } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";

const FIELDS = [
  ["forfait_base", "Forfait prise en charge (€)"],
  ["prix_km", "Prix par km (€)"],
  ["majoration_nuit", "Majoration nuit (€)"],
  ["majoration_dimanche", "Majoration dimanche / férié (€)"],
  ["majoration_accident", "Majoration accident (€)"],
  ["majoration_acces_difficile", "Majoration accès difficile (€)"],
  ["prix_minimum", "Prix minimum (€)"],
  ["prix_sortie_fourriere", "Prix sortie fourrière (€)"],
  ["prix_transport_vehicule", "Prix transport véhicule (€)"],
  ["tva", "TVA (%)"],
];

export default function AdminTariffs() {
  const [t, setT] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get("/admin/settings").then((r) => setT(r.data)).catch(() => {}); }, []);

  const save = async () => {
    setSaving(true);
    try {
      const payload = {};
      FIELDS.forEach(([k]) => { payload[k] = Number(t[k]); });
      const r = await api.patch("/admin/settings", payload);
      setT(r.data);
      toast.success("Tarifs mis à jour");
    } catch (e) { toast.error(formatErr(e)); } finally { setSaving(false); }
  };

  if (!t) return <div className="text-zinc-400">Chargement…</div>;

  return (
    <div>
      <div className="font-heading text-3xl font-black uppercase tracking-tight">Gestion des tarifs</div>
      <div className="h-1 w-16 bg-brand mt-2 mb-6" />
      <div className="bg-ink-900 border border-ink-700 p-5 grid sm:grid-cols-2 gap-4 max-w-3xl">
        {FIELDS.map(([k, label]) => (
          <label key={k} className="block">
            <span className="text-xs uppercase tracking-widest text-zinc-500">{label}</span>
            <input type="number" step="0.01" className="mt-1 w-full h-11 px-3 bg-ink-800 border border-ink-700 focus:border-brand text-white outline-none" value={t[k] ?? ""} onChange={(e) => setT((s) => ({ ...s, [k]: e.target.value }))} data-testid={`tariff-${k}`} />
          </label>
        ))}
      </div>
      <button onClick={save} disabled={saving} className="mt-4 bg-brand text-white font-heading font-black uppercase px-6 py-3 inline-flex items-center gap-2 disabled:opacity-50" data-testid="tariff-save"><Save size={16} /> Enregistrer</button>
      <p className="text-zinc-500 text-xs mt-3">Les modifications sont prises en compte immédiatement par le simulateur de prix public.</p>
    </div>
  );
}
